import * as React from 'react'
import './CustomMetricSelectors.css'
import DropdownMenu from '@mulesoft/anypoint-components/lib/DropdownMenu'
import { CustomMetricError } from './CustomMetricError/CustomMetricError'
import { ValueProps as CustomMetricErrorProps } from './CustomMetricError/CustomMetricError'

export type ValueProps = {
  isAggregationSelectorLoading: boolean,
  aggregations?: string[],
  selectedAggregation?: string,
  
  isMeasureSelectorLoading: boolean,
  measures?: string[],
  selectedMeasure?: string,
  
  isDimensionSelectorLoading: boolean,
  dimensions?: string[],
  selectedDimension?: string,
}

export interface EventProps {
  aggregationSelected: (aggregation: string) => void
  measureSelected: (measure: string) => void
  dimensionSelected: (dimension: string) => void
}

export type Props = ValueProps & EventProps

export default class CustomMetricSelectors extends React.Component<Props> {

  constructor(props: Props) {
    super(props);
  
    // Aggregations bindings
    this.onAggregationsChange = this.onAggregationsChange.bind(this)
    this.getAggregationsPlaceHolder = this.getAggregationsPlaceHolder.bind(this)
    
    // Measures bindings
    this.onMeasuresChange = this.onMeasuresChange.bind(this)
    this.getMeasuresPlaceHolder = this.getMeasuresPlaceHolder.bind(this)
    
    // Dimensions bindings
    this.onDimensionsChange = this.onDimensionsChange.bind(this)
    this.getDimensionsPlaceHolder = this.getDimensionsPlaceHolder.bind(this)

    this.getCustomMetricErrorProps = this.getCustomMetricErrorProps.bind(this)
  }
  
  getOptionsForSelection(array?: string[]) {
    return array ? array.map(obj => {
      return { key: obj, label: obj }
    }) : [];
  }

  getValueForSelection(value?: string) {
    return value ? { key: value, label: value } : undefined
  }

  // Aggregations methods
  getAggregationsPlaceHolder(aggregation: string) {
    if (this.props.isAggregationSelectorLoading) {
      return 'Loading...'
    }

    return aggregation
  }

  onAggregationsChange(e: { value: { key: string, label: string } }) {
    this.props.aggregationSelected(e.value.key)
  }
  
  // Measures methods
  getMeasuresPlaceHolder(measure: string) {
    if (this.props.isMeasureSelectorLoading) {
      return 'Loading...'
    }
    
    return measure
  }
  
  onMeasuresChange(e: { value: { key: string, label: string} }) {
    this.props.measureSelected(e.value.key)
  }
  
  // Dimensions methods
  getDimensionsPlaceHolder(dimension: string) {
    if (this.props.isDimensionSelectorLoading) {
      return 'Loading...'
    }
    
    return dimension
  }
  
  onDimensionsChange(e: { value: { key: string, label: string} }) {
    this.props.dimensionSelected(e.value.key)
  }

  getCustomMetricErrorProps(): CustomMetricErrorProps {
    const { selectedMeasure } = this.props

    return {
      show: selectedMeasure ? (selectedMeasure === 'Select' || selectedMeasure === 'None') : true
    }
  }

  render() {
    const {aggregations, selectedAggregation} = this.props;
    const resolvedAggregations = this.getOptionsForSelection(aggregations)
    const aggregationsPlaceHolder = this.getAggregationsPlaceHolder(selectedAggregation ? selectedAggregation : 'Select')
    const resolvedSelectedAggregation = this.getValueForSelection(selectedAggregation)

    const {measures, selectedMeasure} = this.props;
    const resolvedMeasures = this.getOptionsForSelection(measures)
    const measuresPlaceHolder = this.getMeasuresPlaceHolder(selectedMeasure ? selectedMeasure : 'Select')
    const resolvedSelectedMeasure = this.getValueForSelection(selectedMeasure)

    const {dimensions, selectedDimension} = this.props;
    const resolvedDimensions = this.getOptionsForSelection(dimensions)
    const dimensionsPlaceHolder = this.getDimensionsPlaceHolder(selectedDimension ? selectedDimension : 'Select')
    const resolvedSelectedDimension = this.getValueForSelection(selectedDimension)

    const customMetricErrorProps = this.getCustomMetricErrorProps()

    return (
      <div className="custom-metric-selectors-container">
        <div className="custom-metric-selector">
          <div className="custom-metric-selector measures-label">
            <span>Measures:</span>
          </div>
          <div className="custom-metric-selector aggregations">
            <div data-test-id={'custom-metric-aggregation-label'} className={'custom-metric-selector-label'}>Aggregation:</div>
            <DropdownMenu
              className="custom-metric-select"
              testId="custom-metric-aggregation-select"
              value={resolvedSelectedAggregation}
              options={resolvedAggregations}
              placeholder={aggregationsPlaceHolder}
              onChange={this.onAggregationsChange}
            />
          </div>
          <div className="custom-metric-selector measures">
            <div data-test-id={'custom-metric-measure-label'} className={'custom-metric-selector-label'}>Measurement:</div>
            <DropdownMenu
              className="custom-metric-select"
              testId="custom-metric-measure-select"
              value={resolvedSelectedMeasure}
              options={resolvedMeasures}
              placeholder={measuresPlaceHolder}
              onChange={this.onMeasuresChange}
            />
          </div>
          <div className="custom-metric-selector dimensions">
            <div data-test-id={'custom-metric-dimension-label'} className={'custom-metric-selector-label'}>Group by:</div>
            <DropdownMenu
              className="custom-metric-select"
              testId="custom-metric-dimension-select"
              value={resolvedSelectedDimension}
              options={resolvedDimensions}
              placeholder={dimensionsPlaceHolder}
              onChange={this.onDimensionsChange}
            />
          </div>
        </div>
        <div className="custom-metric-selector-error">
          <CustomMetricError {...customMetricErrorProps} />
        </div>
      </div>
    );
  }
}